module.exports = __webpack_public_path__ + "img/icon04.3a7d0ab4.png";